/**
 * Prototype-only hourly profile for admin peak-load chart (no API).
 * Shape mimics typical UB payment traffic; replaced when GET /admin/trafficPeak exists.
 */

/** @param {number} hour 0–23 */
function baseVolume(hour) {
  const lunch = Math.exp(-((hour - 12) ** 2) / 8) * 420;
  const evening = Math.exp(-((hour - 19) ** 2) / 6) * 380;
  const morning = Math.exp(-((hour - 9) ** 2) / 10) * 260;
  const night = hour >= 0 && hour <= 5 ? 25 + hour * 8 : 0;
  return Math.round(80 + lunch + evening + morning + night);
}

/**
 * @returns {Array<{ label: string, hour: number, createdCount: number, paidCount: number }>}
 */
export function buildMockPeakLoadByHourOfDay() {
  return Array.from({ length: 24 }, (_, hour) => {
    const created = baseVolume(hour);
    const paid = Math.round(created * (0.72 + (hour % 5) * 0.02));
    const label = `${String(hour).padStart(2, "0")}:00`;
    return { label, hour, createdCount: created, paidCount: paid };
  });
}

/**
 * @param {Array<{ createdCount: number, paidCount: number, label: string }>} buckets
 */
export function findPeakBucket(buckets, key) {
  if (!buckets?.length) return null;
  let best = buckets[0];
  for (let i = 1; i < buckets.length; i += 1) {
    if (buckets[i][key] > best[key]) best = buckets[i];
  }
  const endHour = (best.hour + 1) % 24;
  const endLabel = `${String(endHour).padStart(2, "0")}:00`;
  return {
    label: `${best.label}–${endLabel}`,
    count: best[key],
    hour: best.hour,
  };
}
